export interface CountryCode {
    code: string;
    name: string;
    flag: string;
    short: string;
  }

  export const List_of_languages_to_be_displayed = [
    "Afrikaans",
    "Akan",
    "Albanian",
    "Amharic",
    "Arabic",
    "Armenian",
    "Assamese",
    "Aymara",
    "Azerbaijani",
    "Bashkir",
    "Basque",
    "Belarusian",
    "Bengali",
    "Bhojpuri",
    "Bosnian",
    "Breton",
    "Bulgarian",
    "Burmese",
    "Catalan",
    "Cebuano",
    "Chamorro",
    "Chichewa",
    "Chinese (Simplified)",
    "Chinese (Traditional)",
    "Chuvash",
    "Corsican",
    "Cree",
    "Croatian",
    "Czech",
    "Danish",
    "Dari",
    "Divehi",
    "Dogri",
    "Dutch",
    "Dzongkha",
    "English",
    "Esperanto",
    "Estonian",
    "Ewe",
    "Fijian",
    "Filipino (Tagalog)",
    "Finnish",
    "Flemish",
    "French",
    "Frisian",
    "Fulah",
    "Galician",
    "Georgian",
    "German",
    "Greek",
    "Guarani",
    "Gujarati",
    "Haitian Creole",
    "Hausa",
    "Hawaiian",
    "Hebrew",
    "Hindi",
    "Hmong",
    "Hungarian",
    "Icelandic",
    "Igbo",
    "Ilocano",
    "Indonesian",
    "Inuktitut",
    "Irish",
    "Italian",
    "Japanese",
    "Javanese",
    "Kannada",
    "Kazakh",
    "Khmer",
    "Kinyarwanda",
    "Kirghiz",
    "Konkani",
    "Korean",
    "Kurdish",
    "Lao",
    "Latin",
    "Latvian",
    "Lingala",
    "Lithuanian",
    "Luxembourgish",
    "Macedonian",
    "Malagasy",
    "Malay",
    "Malayalam",
    "Maltese",
    "Maori",
    "Marathi",
    "Mongolian",
    "Manipuri",
    "Nepali",
    "Norwegian",
    "Nyanja",
    "Odia (Oriya)",
    "Ojibwe",
    "Pashto",
    "Persian (Farsi)",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Quechua",
    "Romanian",
    "Romansh",
    "Russian",
    "Samoan",
    "Sanskrit",
    "Scots Gaelic",
    "Serbian",
    "Sesotho",
    "Shona",
    "Sindhi",
    "Sinhala",
    "Slovak",
    "Slovenian",
    "Somali",
    "Spanish",
    "Sundanese",
    "Swahili",
    "Swedish",
    "Tahitian",
    "Tajik",
    "Tamil",
    "Tatar",
    "Telugu",
    "Thai",
    "Tibetan",
    "Tigrinya",
    "Tok Pisin",
    "Tswana",
    "Turkish",
    "Turkmen",
    "Ukrainian",
    "Urdu",
    "Uyghur",
    "Uzbek",
    "Vietnamese",
    "Volapük",
    "Walloon",
    "Welsh",
    "Wolof",
    "Xhosa",
    "Yiddish",
    "Yoruba",
    "Zulu",
  ];
  export const List_of_countries_to_be_displayed = [
    "Albania",
    "Algeria",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Belgium",
    "Benin",
    "Bhutan",
    "BoliBolivia (Plurinational State of)via",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brunei Darussalam",
    "Bulgaria",
    "Cambodia",
    "Canada",
    "Chile",
    "Colombia",
    "Costa Rica",
    "Côte d’Ivoire",
    "Croatia",
    "Cyprus",
    "Czechia",
    "Denmark",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Estonia",
    "Ethiopia",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Germany",
    "Ghana",
    "Greece",
    "Guatemala",
    "Guyana",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Ireland",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kuwait",
    "Lao People's Democratic Republic",
    "Latvia",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malaysia",
    "Malta",
    "Mauritius",
    "Mexico",
    "Republic of Moldova",
    "Monaco",
    "Mongolia",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Netherlands",
    "New Zealand",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Panama",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Rwanda",
    "San Marino",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "South Africa",
    "Korea (Republic of)",
    "Spain",
    "Sri Lanka",
    "Saint Lucia",
    "Sweden",
    "Switzerland",
    "Taiwan (Province of China)",
    "Tanzania (United Republic of)",
    "Thailand",
    "Trinidad and Tobago",
    "Tunisia",
    "Türkiye",
    "United Arab Emirates",
    "United Kingdom of Great Britain and Northern Ireland",
    "Uruguay",
    "Uzbekistan",
    "Viet Nam",
    "Bolivia",
    "Côte d’Ivoire",
    "Moldova",
    "Netherlands",
    "South Korea",
    "Taiwan",
    "Tanzania",
  ];
  

export const countries: CountryCode[] = [
    { name: "United States", code: "+1", short: "US", flag: "🇺🇸" },
    { name: "Albania", code: "+355", short: "AL", flag: "🇦🇱" },
    { name: "Algeria", code: "+213", short: "DZ", flag: "🇩🇿" },
    { name: "Angola", code: "+244", short: "AO", flag: "🇦🇴" },
    { name: "Antigua & Barbuda", code: "+1-268", short: "AG", flag: "🇦🇬" },
    { name: "Argentina", code: "+54", short: "AR", flag: "🇦🇷" },
    { name: "Armenia", code: "+374", short: "AM", flag: "🇦🇲" },
    { name: "Australia", code: "+61", short: "AU", flag: "🇦🇺" },
    { name: "Austria", code: "+43", short: "AT", flag: "🇦🇹" },
    { name: "Azerbaijan", code: "+994", short: "AZ", flag: "🇦🇿" },
    { name: "Bahamas", code: "+1-242", short: "BS", flag: "🇧🇸" },
    { name: "Bahrain", code: "+973", short: "BH", flag: "🇧🇭" },
    { name: "Bangladesh", code: "+880", short: "BD", flag: "🇧🇩" },
    { name: "Belgium", code: "+32", short: "BE", flag: "🇧🇪" },
    { name: "Benin", code: "+229", short: "BJ", flag: "🇧🇯" },
    { name: "Bhutan", code: "+975", short: "BT", flag: "🇧🇹" },
    { name: "Bolivia", code: "+591", short: "BO", flag: "🇧🇴" },
    { name: "Bosnia & Herzegovina", code: "+387", short: "BA", flag: "🇧🇦" },
    { name: "Botswana", code: "+267", short: "BW", flag: "🇧🇼" },
    { name: "Brunei", code: "+673", short: "BN", flag: "🇧🇳" },
    { name: "Bulgaria", code: "+359", short: "BG", flag: "🇧🇬" },
    { name: "Cambodia", code: "+855", short: "KH", flag: "🇰🇭" },
    { name: "Canada", code: "+1", short: "CA", flag: "🇨🇦" },
    { name: "Chile", code: "+56", short: "CL", flag: "🇨🇱" },
    { name: "Colombia", code: "+57", short: "CO", flag: "🇨🇴" },
    { name: "Costa Rica", code: "+506", short: "CR", flag: "🇨🇷" },
    { name: "Côte d’Ivoire", code: "+225", short: "CI", flag: "🇨🇮" },
    { name: "Croatia", code: "+385", short: "HR", flag: "🇭🇷" },
    { name: "Cyprus", code: "+357", short: "CY", flag: "🇨🇾" },
    { name: "Czech Republic", code: "+420", short: "CZ", flag: "🇨🇿" },
    { name: "Denmark", code: "+45", short: "DK", flag: "🇩🇰" },
    { name: "Dominican Republic", code: "+1-809", short: "DO", flag: "🇩🇴" },
    { name: "Ecuador", code: "+593", short: "EC", flag: "🇪🇨" },
    { name: "Egypt", code: "+20", short: "EG", flag: "🇪🇬" },
    { name: "El Salvador", code: "+503", short: "SV", flag: "🇸🇻" },
    { name: "Estonia", code: "+372", short: "EE", flag: "🇪🇪" },
    { name: "Ethiopia", code: "+251", short: "ET", flag: "🇪🇹" },
    { name: "Finland", code: "+358", short: "FI", flag: "🇫🇮" },
    { name: "France", code: "+33", short: "FR", flag: "🇫🇷" },
    { name: "Germany", code: "+49", short: "DE", flag: "🇩🇪" },
    { name: "Ghana", code: "+233", short: "GH", flag: "🇬🇭" },
    { name: "Greece", code: "+30", short: "GR", flag: "🇬🇷" },
    { name: "India", code: "+91", short: "IN", flag: "🇮🇳" },
    { name: "Indonesia", code: "+62", short: "ID", flag: "🇮🇩" },
    { name: "Ireland", code: "+353", short: "IE", flag: "🇮🇪" },
    { name: "Israel", code: "+972", short: "IL", flag: "🇮🇱" },
    { name: "Italy", code: "+39", short: "IT", flag: "🇮🇹" },
    { name: "Japan", code: "+81", short: "JP", flag: "🇯🇵" },
    { name: "Malaysia", code: "+60", short: "MY", flag: "🇲🇾" },
    { name: "Mexico", code: "+52", short: "MX", flag: "🇲🇽" },
    { name: "Netherlands", code: "+31", short: "NL", flag: "🇳🇱" },
    { name: "New Zealand", code: "+64", short: "NZ", flag: "🇳🇿" },
    { name: "Nigeria", code: "+234", short: "NG", flag: "🇳🇬" },
    { name: "Norway", code: "+47", short: "NO", flag: "🇳🇴" },
    { name: "Pakistan", code: "+92", short: "PK", flag: "🇵🇰" },
    { name: "Philippines", code: "+63", short: "PH", flag: "🇵🇭" },
    { name: "Poland", code: "+48", short: "PL", flag: "🇵🇱" },
    { name: "Portugal", code: "+351", short: "PT", flag: "🇵🇹" },
    { name: "Qatar", code: "+974", short: "QA", flag: "🇶🇦" },
    { name: "Romania", code: "+40", short: "RO", flag: "🇷🇴" },
    { name: "Saudi Arabia", code: "+966", short: "SA", flag: "🇸🇦" },
    { name: "Singapore", code: "+65", short: "SG", flag: "🇸🇬" },
    { name: "South Africa", code: "+27", short: "ZA", flag: "🇿🇦" },
    { name: "South Korea", code: "+82", short: "KR", flag: "🇰🇷" },
    { name: "Spain", code: "+34", short: "ES", flag: "🇪🇸" },
    { name: "Sweden", code: "+46", short: "SE", flag: "🇸🇪" },
    { name: "Switzerland", code: "+41", short: "CH", flag: "🇨🇭" },
    { name: "United Arab Emirates", code: "+971", short: "AE", flag: "🇦🇪" },
    { name: "United Kingdom", code: "+44", short: "GB", flag: "🇬🇧" },
    { name: "Vietnam", code: "+84", short: "VN", flag: "🇻🇳" }
  ];
  


    type CustomCountryNames = {
      [key: string]: string;
    };
  
    export const customCountryNames: CustomCountryNames = {
      "Viet Nam": "Vietnam",
      "United Kingdom of Great Britain and Northern Ireland": "United Kingdom",
      Türkiye: "Turkey",
      "Trinidad and Tobago": "Trinidad & Tobago",
      "Tanzania (United Republic of)": "Tanzania",
      "Taiwan (Province of China)": "Taiwan",
      "Saint Lucia": "St. Lucia",
      "Korea (Republic of)": "South Korea",
      Netherlands: "Netherlands",
      "Republic of Moldova": "Moldova",
      Macao: "Macao SAR China",
      "Lao People's Democratic Republic": "Laos",
      Czechia: "Czech Republic",
      //"Côte d’Ivoire": "Côte d’Ivoire",
      "Brunei Darussalam": "Brunei",
      "Bosnia and Herzegovina": "Bosnia & Herzegovina",
      "Bolivia (Plurinational State of)": "Bolivia",
      "Antigua and Barbuda": "Antigua & Barbuda",
      Bolivia: "Bolivia",
      "Côte d’Ivoire": "Côte d'Ivoire",
      Moldova: "Moldova",
      "South Korea": "South Korea",
      Taiwan: "Taiwan",
      Tanzania: "Tanzania",
    };
  